export const createHeaders = (users: any[]) => {
	const usersWithHeader = [];
	const headerSet = new Set<string>();
	users.map((user) => (user.name = user.name || user.personal.name));
	users.map((user) => headerSet.add(user.name.substring(0, 1).toLowerCase()));
	const headers = Array.from(headerSet).sort((a, b) => a.localeCompare(b));

	for (const header of headers) {
		usersWithHeader.push({
			header,
			values: users.filter((user) => user.name.substring(0, 1).toLowerCase() === header),
		});
	}

	return usersWithHeader;
};
